import React, { Component } from "react";
import PropTypes from "prop-types";

class RollTitle extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([PropTypes.node, PropTypes.func])
    };

    render() {
        const { children } = this.props;

        return <div className="roll-title">{children}</div>;
    }
}

export default RollTitle;



// WEBPACK FOOTER //
// ./src/scripts/components/RollTitle.js